import React, { useState } from "react";
import "./login-form2.styles.scss";
import LoginHead from "../login-head/login-head.component";
import Button from "../button/button.component";
import UserIcon from "../icons/user/user.component";
import LockIcon from "../icons/lock/lock.component";
import { EyeInvisibleIcon, EyeVisibleIcon } from "../icons/eye/eye.component";
import InputField from "../input-field/input-field.component";

interface IProps {
    error?: string | null;
    handleChange: (evt: any, name: string) => void;
    handleClick: (evt: any) => void;
}

export default function LoginForm2({
    error,
    handleChange,
    handleClick,
}: IProps) {
    const [onFocusUsername, setOnFocusUsername] = useState<boolean>(false);
    const [onFocusPassword, setOnFocusPassword] = useState<boolean>(false);
    const [visible, setVisible] = useState<boolean>(false);

    const changeVisible = () => {
        setVisible(!visible);
    };

    return (
        <div className="login">
            <LoginHead />
            <form className="login__form" action="#" method="post">
                <div className="login__form__input">
                    <span className="login__form__input__custom">
                        <div className="icon-wrap">
                            <UserIcon
                                color={
                                    onFocusUsername
                                        ? "var(--link-color)"
                                        : "rgb(150, 150, 150)"
                                }
                                size={1.5}
                            />
                        </div>
                        <InputField
                            type="text"
                            name="login-email"
                            label="Binusian Email"
                            onFocus={() => setOnFocusUsername(true)}
                            onBlur={() => setOnFocusUsername(false)}
                            onChange={(evt) => handleChange(evt, "username")}
                            autoFocus
                            login
                        />
                    </span>
                </div>
                <div className="login__form__input">
                    <span className="login__form__input__custom">
                        <div className="icon-wrap">
                            <LockIcon
                                className="icon"
                                color={
                                    onFocusPassword
                                        ? "var(--link-color)"
                                        : "rgb(150, 150, 150)"
                                }
                                size={1.5}
                            />
                        </div>
                        <InputField
                            type={visible ? "text" : "password"}
                            name="login-password"
                            label="Password"
                            onFocus={() => setOnFocusPassword(true)}
                            onBlur={() => setOnFocusPassword(false)}
                            onChange={(evt) => handleChange(evt, "password")}
                            login
                        />
                        <div className="eye-icon" onClick={changeVisible}>
                            {visible ? (
                                <EyeVisibleIcon
                                    color={
                                        onFocusPassword
                                            ? "var(--link-color)"
                                            : "rgb(150, 150, 150)"
                                    }
                                    size={1.5}
                                />
                            ) : (
                                <EyeInvisibleIcon
                                    color={
                                        onFocusPassword
                                            ? "var(--link-color)"
                                            : "rgb(150, 150, 150)"
                                    }
                                    size={1.5}
                                />
                            )}
                        </div>
                    </span>
                </div>
                {error ? (
                    <div className="login__form__error error">{error}</div>
                ) : (
                    ""
                )}
                <Button className="login__form__button" onClick={handleClick}>
                    Login
                </Button>
            </form>
        </div>
    );
}
